import {theme} from "../../theme.js";

export const monthNames = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export const getDaysInMonth = (date) => {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
};

export const getFirstDayOfMonth = (date) => {
  const day = new Date(date.getFullYear(), date.getMonth(), 1).getDay();
  // Convert Sunday=0 (JS) to Sunday=6 so week starts on Monday
  return (day + 6) % 7;
};

export const isSameDay = (date1, date2) => {
  return (
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  );
};

export const formatDate = (date) => {
  if (!date) return "Select date";
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export const styles = {
  container: {
    backgroundColor: theme.colors.bgLight,
    borderRadius: "8px",
    padding: "16px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
    paddingBottom: "12px",
    borderBottom: `1px solid ${theme.colors.gray200}`,
  },
  dateDisplay: {
    display: "flex",
    gap: "20px",
    alignItems: "center",
  },
  separator: {
    fontSize: "14px",
    color: theme.colors.gray200,
  },
  label: {
    display: "block",
    fontSize: "11px",
    color: theme.colors.gray600,
    fontWeight: "500",
    marginBottom: "2px",
  },
  dateValue: {
    display: "block",
    fontSize: "14px",
    fontWeight: "600",
    color: theme.colors.textPrimary,
  },
  resetBtn: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    backgroundColor: "transparent",
    color: theme.colors.gray600,
    border: "none",
    fontSize: "14px",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  calendarsContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
    marginBottom: "16px",
  },
  calendarWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    marginBottom: "16px",
  },
  calendar: {
    flex: 1,
  },
  monthTitle: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.colors.textInverted,
    margin: "0 0 12px 0",
    textAlign: "center",
  },
  weekDays: {
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    gap: "4px",
    marginBottom: "8px",
  },
  weekDay: {
    fontSize: "11px",
    fontWeight: "600",
    color: theme.colors.textMuted,
    textAlign: "center",
    padding: "4px 0",
  },
  daysGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    gap: "4px",
    minHeight: "252px",
    gridAutoRows: "minmax(0, 1fr)",
  },
  day: {
    padding: "8px",
    border: "none",
    backgroundColor: "transparent",
    color: theme.colors.textInverted,
    fontSize: "12px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
    borderRadius: "4px",
    aspectRatio: "1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  selectedDay: {
    backgroundColor: theme.colors.light,
    color: theme.colors.textInverted,
    fontWeight: "600",
    borderRadius: "50%",
  },
  inRangeDay: {
    backgroundColor: theme.colors.light + "30",
    color: theme.colors.textInverted,
    borderRadius: "2px",
  },
  emptyCell: {
    padding: "8px",
  },
  navBtn: {
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    backgroundColor: theme.colors.bgLight,
    border: "none",
    fontSize: "14px",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    gap: "8px",
    paddingTop: "12px",
    borderTop: `1px solid ${theme.colors.border}`,
  },
  backBtn: {
    padding: "8px 16px",
    backgroundColor: "transparent",
    color: theme.colors.textInverted,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: "6px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  doneBtn: {
    padding: "8px 20px",
    backgroundColor: theme.colors.light,
    color: theme.colors.textInverted,
    border: "none",
    borderRadius: "6px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
};
